var $5aab65a56d47e888$exports = {};
$5aab65a56d47e888$exports = {
    "collapse": `Contraer`,
    "expand": `Ampliar`
};


export {$5aab65a56d47e888$exports as default};
//# sourceMappingURL=es-ES.mjs.map
